import { render, staticRenderFns } from "./tambah.vue?vue&type=template&id=374ea222"
import script from "./tambah.vue?vue&type=script&lang=js"
export * from "./tambah.vue?vue&type=script&lang=js"
import style0 from "./tambah.vue?vue&type=style&index=0&id=374ea222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports